<template>
    <div class="flex justify-end mt-2">
        <Button variant="dismissive" @click="$emit('closeDialog')">
            Cancelar
        </Button>
        <Button
            v-if="showNext"
            :disabled="disableNext"
            @click="$emit('goToNext')"
        >
            Siguiente
        </Button>
        <Button :loading="loading" v-if="showProcess" @click="$emit('create')">
            Solicitar
        </Button>
    </div>
</template>

<script>
import Button from "@/shared/Button.vue";
export default {
    name: "MultistepNavigator",
    components: {
        Button,
    },
    props: {
        processState: Object,
        showNext: Boolean,
        disableNext: Boolean,
        showProcess: Boolean,
        loading: Boolean,
    },
};
</script>
